import API_ENDPOINTS from '../constants/api_endpoints';
import { realBricksApi } from './api.service';

export const uploadMediaService = (body) => {
  return realBricksApi.post(API_ENDPOINTS.MEDIA.PreSignedUploadUrl, body);
};

export const uploadEmailMediaService = (body) => {
  return realBricksApi.post(API_ENDPOINTS.MEDIA.PreSignedBulkEmail, body);
};
